import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import axios from 'axios';
import './Index.css'
import { faArrowLeft, faArrowRight, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TaskRTrackerModalUpdate from '../TaskR/Tracker/ModalUpdate';
import TaskRSettingModalUpdate from '../TaskR/Setting/ModalUpdate';
import TaskModalUpdate from '../Task/ModalUpdate';
import DateStartEnd from './DateStartEnd';
import { update as taskRTrackerUpdate, loadLabelList as taskRTrackerLoadLabelList, loadUserList as taskRTrackerLoadUserList, loadCheckList as taskRTrackerLoadCheckList } from '../../../reducers/models/taskRTracker/taskRTrackerList';
import { update as taskRUpdate, loadLabelList as taskRLoadLabelList, loadUserList as taskRLoadUserList, loadCheckList as taskRLoadCheckList } from '../../../reducers/models/taskR/taskRlist';
import { update as taskUpdate, loadLabelList as taskLoadLabelList, loadUserList as taskLoadUserList, loadCheckList as taskLoadCheckList } from '../../../reducers/models/task/taskList';
import { useDispatch } from 'react-redux';
import ErrorAdd from "../../../util/ErrorAdd";

function Index() {

    const dispatch = useDispatch()

    const [calendar, setCalendar] = useState([]);

    const [year, setYear] = useState(null);
    const [month, setMonth] = useState(null);

    const monthStr = [{ id: 0, name: 'Январь' }, { id: 1, name: 'Февраль' }, { id: 2, name: 'Март' }, { id: 3, name: 'Апрель' }, { id: 4, name: 'Май' }, { id: 5, name: 'Июнь' }, { id: 6, name: 'Июль' }, { id: 7, name: 'Авгут' }, { id: 8, name: 'Сентябрь' }, { id: 9, name: 'Октябрь' }, { id: 10, name: 'Ноябрь' }, { id: 11, name: 'Декабрь' }]

    useEffect(() => {
        const date = new Date();
        setYear(date.getFullYear());
        setMonth(date.getMonth());
    }, []);

    useEffect(() => {
        if (year != null & month != null) {
            const days = calendarDayGenerate(year, month);
            const date = new Date(year, month, 1);

            const date_start = format(date, 'yyyy-MM-dd');//Пример 01.01.2026г
            const date_end = format(addMonth(date, 1), 'yyyy-MM-dd');//Пример 01.02.2026г

            axios.get('/api_tracker/other/calendarMonthList', { params: { Date_Start: date_start, Date_End: date_end } })
                .then((res) => {
                    const calendar_ = days.map(d => {
                        var date_end = new Date(d.date);
                        date_end.setDate(date_end.getDate() + 1);

                        //const tasks = res.data.Data.filter(a => new Date(a.Date_Start) <= new Date(item.date) & new Date(a.Date_End) >= new Date(item.date));
                        //const tasks = res.data.Data.filter(a => Date.parse(a.Date_Start) === Date.parse(d.date));
                        const tasks = res.data.Data.filter(a => Date.parse(a.Date_Start) >= Date.parse(d.date) & Date.parse(a.Date_Start) < Date.parse(date_end));

                        return {
                            ...d, tasks: tasks
                        }
                    })
                    setCalendar(calendar_);
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });
        }
    }, [year, month]);

    //Сгенерирует дни календаря на указанный день и месяц
    function calendarDayGenerate(year, month) {
        const date_today = new Date();
        const date_today_date = date_today.getDate();
        const date_today_month = date_today.getMonth();
        const date_today_year = date_today.getFullYear();

        const date = new Date(year, month, 1);
        const week_day = date.getDay();//День недели

        const before_add_day = week_day === 0 ? 6 : week_day - 1;//Кол-во дней для добавления перед 1м числом месяца
        //const after_add_day = 0;//Кол-во дней для добавления после последнего числа месяца

        const first_date = addDays(date, 0 - before_add_day)
        //const last_date = addDays(first_date, 41)

        var days = [];

        for (let i = 0; i < 42; i++) {
            const date_ = addDays(first_date, i);
            const month_ = date_.getMonth();
            const year_ = date_.getFullYear();

            var current_ = false;//Текущий месяц
            var today = false;//Текущий день

            if (year === year_ & month === month_) {
                current_ = true;
            }
            if (date_today_date === date_.getDate() & date_today_month === month_ & date_today_year === year_) {
                today = true;
            }

            days.push({ date: date_, day: date_.getDate(), current: current_, today: today })
        }

        //loadData(date, addMonth(date, 1))

        return days;
    }
    //Изменит месяц на указанное количество месяцев
    function changeMonth(step) {
        const date = new Date(year, month, 1);
        const new_date = addMonth(date, step);

        setYear(new_date.getFullYear());
        setMonth(new_date.getMonth());
    }
    //Изменит месяц на текущий
    function changeMonthToday() {
        const date = new Date();
        setYear(date.getFullYear());
        setMonth(date.getMonth());
    }
    //Функция добавит дни к дате
    function addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }
    //Функция добавит месяц к дате
    function addMonth(date, month) {
        const result = new Date(date);
        result.setMonth(result.getMonth() + month);
        return result;
    }

    /***************************************START ЗАДАЧИ**************************************/
    const [modalTaskRShow, setModalTaskRShow] = useState(false);
    const [modalTaskROnlyReadShow, setModalTaskROnlyReadShow] = useState(false);
    const [modalTaskShow, setModalTaskShow] = useState(false);
    const [modalNoTaskShow, setModalNoTaskShow] = useState(false);
    const [modelTaskR, setModelTaskR] = useState(null);
    const [modelTaskROnlyRead, setModelTaskROnlyRead] = useState(null);
    const [modelTask, setModelTask] = useState(null);

    function loadDataForTaskRTracker(id_tasks_r, id_tasks_r_tracker) {
        //Подгружаем метки
        axios.get('/api_tracker/taskR/widgetLabelListByTasks', { params: { ID_Tasks: id_tasks_r } })
            .then((resLabel) => {
                dispatch(taskRTrackerLoadLabelList({ list: resLabel.data.Data, id_tab: -1 }));
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
        //Подгружаем чек-боксы
        axios.get('/api_tracker/taskR/widgetTrackerCheckListByTasks', { params: { ID_Tasks: id_tasks_r_tracker } })
            .then((resCheckList) => {
                dispatch(taskRTrackerLoadCheckList({ list: resCheckList.data.Data, id_tab: -1 }));
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
        //Подгружаем пользователей
        axios.get('/api_tracker/taskR/trackerUserListByTasks', { params: { ID_Tasks: id_tasks_r_tracker } })
            .then((resUser) => {
                dispatch(taskRTrackerLoadUserList({ list: resUser.data.Data, id_tab: -1 }));
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }
    function loadDataForTaskR(id_tasks_r) {
        //Подгружаем метки
        axios.get('/api_tracker/taskR/WidgetLabelListByTasks', { params: { ID_Tasks: id_tasks_r } })
            .then((resLabel) => {
                if (resLabel.data.Status === 1) {
                    dispatch(taskRLoadLabelList({ list: resLabel.data.Data, id_tab: -1 }));
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
        //Ответственные
        axios.get('/api_tracker/taskR/UserListByTasks', { params: { ID_Tasks: id_tasks_r } })
            .then((res_user) => {
                if (res_user.data.Status === 1) {
                    dispatch(taskRLoadUserList({ list: res_user.data.Data, id_tab: -1 }));
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
        //Подгружаем чек-боксы
        axios.get('/api_tracker/taskR/widgetCheckListByTasks', { params: { ID_Tasks: id_tasks_r } })
            .then((resCheckList) => {
                if (resCheckList.data.Status === 1) {
                    dispatch(taskRLoadCheckList({ list: resCheckList.data.Data, id_tab: -1 }));
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }
    function loadDataForTask(id_tasks) {
        //Подгружаем метки
        axios.get('/api_tracker/task/widgetLabelListByTasks', { params: { ID_Tasks: id_tasks } })
            .then((res) => {
                dispatch(taskLoadLabelList({ list: res.data.Data, id_tab: -1 }));
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
        //Подгружаем чек-боксы
        axios.get('/api_tracker/task/widgetCheckListByTasks', { params: { ID_Tasks: id_tasks } })
            .then((res) => {
                dispatch(taskLoadCheckList({ list: res.data.Data, id_tab: -1 }));
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
        //Подгружаем пользователей
        axios.get('/api_tracker/task/userListByTasks', { params: { ID_Tasks: id_tasks } })
            .then((res) => {
                dispatch(taskLoadUserList({ list: res.data.Data, id_tab: -1 }));
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }

    function taskModal(id, id_task_r, type) {
        if (type === 'TaskR') {

            if (id == null) {
                axios.get('/api_tracker/taskR/get', { params: { ID_TaskR: id_task_r } })
                    .then((res) => {
                        setModelTaskROnlyRead(res.data.Data);
                        dispatch(taskRUpdate({ model: res.data.Data, calendar: true }));

                        loadDataForTaskR(id_task_r);
                        setModalTaskROnlyReadShow(true);
                    })
                    .catch((err) => {
                        ErrorAdd(err, window.location.href);
                    });
            }
            else {
                axios.get('/api_tracker/taskR/trackerGet', { params: { ID_TaskR_Tracker: id } })
                    .then((res) => {
                        setModelTaskR(res.data.Data);
                        dispatch(taskRTrackerUpdate({ model: res.data.Data, calendar: true }));
                        loadDataForTaskRTracker(id_task_r, id);
                        setModalTaskRShow(true);
                    })
                    .catch((err) => {
                        ErrorAdd(err, window.location.href);
                    });
            }
        }
        if (type === 'Task') {
            axios.get('/api_tracker/task/get', { params: { ID_Task: id } })
                .then((res) => {
                    setModelTask(res.data.Data);
                    dispatch(taskUpdate({ model: res.data.Data, calendar: true }));
                    loadDataForTask(id);
                    setModalTaskShow(true);
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });
        }
    }
    /****************************************END ЗАДАЧИ***************************************/


    return (
        <div className='admin_content'>

            {modalTaskRShow === true && (
                <TaskRTrackerModalUpdate show={modalTaskRShow} onHide={() => setModalTaskRShow(false)} model={modelTaskR} calendar={true} />
            )}
            {modalTaskROnlyReadShow === true && (
                <TaskRSettingModalUpdate show={modalTaskROnlyReadShow} onHide={() => setModalTaskROnlyReadShow(false)} idTask={modelTaskROnlyRead.ID} edit={true} calendar={true} />
            )}
            {modalTaskShow === true && (
                <TaskModalUpdate show={modalTaskShow} onHide={() => setModalTaskShow(false)} idTask={modelTask.ID} edit={true} calendar={true} />
            )}
            <div className='calendar_header'>
                <div className='calendar_header_month'>{month !== null && monthStr.filter(a => a.id === month)[0].name} {year}г</div>
                <div className='calendar_header_arrow'>
                    <div className='mr-15'>
                        <button className="btn-square btn-hover-shine btn btn-secondary" onClick={() => changeMonthToday()}>Сегодня</button>
                    </div>
                    <div className='mr-5'>
                        <button className="btn-square btn-hover-shine btn btn-secondary" onClick={() => changeMonth(-1)}><FontAwesomeIcon icon={faArrowLeft} className="mr-5" /></button>
                    </div>
                    <div>
                        <button className="btn-square btn-hover-shine btn btn-secondary" onClick={() => changeMonth(1)}><FontAwesomeIcon icon={faArrowRight} className="mr-5" /></button>
                    </div>
                </div>
            </div>
            <div className='calendar'>
                <div className='calendar_block_week'>
                    <div className='calendar_week_item'>ПН</div>
                    <div className='calendar_week_item'>ВТ</div>
                    <div className='calendar_week_item'>СР</div>
                    <div className='calendar_week_item'>ЧТ</div>
                    <div className='calendar_week_item'>ПТ</div>
                    <div className='calendar_week_item'>СБ</div>
                    <div className='calendar_week_item'>ВС</div>
                </div>
                <div className='calendar_block_day'>
                    {calendar.map((item) => (
                        <div key={item.date} className={'calendar_item' + (item.current !== true ? ' current' : '') + (item.today === true ? ' today' : '')}>
                            <div className='calendar_day'>{item.day}</div>
                            <div className='calendar_task_block'>
                                {item.tasks.map((task) => (
                                    <div key={Math.random()} id={task.ID} className='calendar_task' onClick={() => taskModal(task.ID, task.ID_TaskR, task.Type)}>
                                        <div className={task.Completed === true ? 'completed' : ''}  >{task.Name}</div>
                                        <div>
                                            {task.ID_Timetable_Type === 1 ? (
                                                <div>
                                                    <FontAwesomeIcon icon={faClock} className='mr-5' />
                                                    {format(new Date(task.Date_Start), 'HH:mm')}
                                                </div>
                                            ) : (
                                                <DateStartEnd date_start={task.Date_Start} date_end={task.Date_End} date_completed={task.Date_Completed} />
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default Index;